import React, { memo } from 'react';
import { SidebarBoundary } from '@atlassian/jira-navigation-apps-sidebar-nav4-sidebars-common-core/src/ui/sidebar-boundary/index.tsx';
import type { JpdProjectMenuProps } from '@atlassian/jira-navigation-apps-sidebar-nav4-sidebars-content-projects-jpd-project-menu/src/ui/JpdProjectMenu.tsx';
import { Skeleton } from '@atlassian/jira-navigation-apps-sidebar-nav4-sidebars-settings-project-common/src/common/ui/skeleton/index.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

const LazySidebarContent = lazyForPaint(() =>
	import(
		/* webpackChunkName: "async-jira-navigation-apps-sidebar-nav4-sidebar-jpd-project-menu" */ './ui'
	).then(({ JpdProjectMenu }) => JpdProjectMenu),
);

export const AsyncJpdProjectMenu = memo(({ projectData, spotlight }: JpdProjectMenuProps) => (
	<SidebarBoundary
		id="nav4.sidebar.jpd-project-menu"
		packageName="jiraNavigationAppsSidebarNav4JPDProjectMenu"
		ufoName="nav4.sidebar.jpd-project-menu"
	>
		<Placeholder name="nav4.sidebar.jpd-project-menu" fallback={<Skeleton />}>
			<LazySidebarContent projectData={projectData} spotlight={spotlight} />
		</Placeholder>
	</SidebarBoundary>
));
